<style lang="scss">

    .licenses{
        margin-top: 30px;
        .widget-title{
            color: #ff5b94;
            font-family: Poppins;
            font-size: 30px;
            font-weight: 600;
            text-transform: uppercase;
    }

        .owl-carousel{
            display: none;
    }

        .licenses-wrapper {
            display: flex;
            justify-content: center;
            margin-left: -10px;
            margin-right: -10px;
            height: 570px;

            .licenses-panel  {
                flex: 1;
                max-width: 100%;
                margin: 0 10px;
                border: 4px solid rgba(132, 65, 164, 0.22);
                border-radius: 5px !important;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                /*padding: 20px 25px 20px 25px;*/
                height: 545px;
                background-color : #ffffff;
                &:hover {
                    border-color: #e15498;
            }
        }

            .simple-block{
                width : 300px !important;
                flex: unset !important;
                display: block !important;
                flex-direction: unset !important;
        }

            .highlighted{
                background-image: linear-gradient(152deg, #ff5b94 0%, #8441a4 100%);
                border-radius: 5px !important;
                .license-discounts {
                    background-color: #ffffff;
                    color: #e15498;
                    z-index: 3;
            }

                .license-name {
                    color: #ffffff;
            }

                .license-terms-line{
                    color: #ffffff;
            }

                .price{
                    color: #ffffff;
            }
        }
    }

        .licenses-wrapper{
            .carousel-3d-container {
                height: 545px !important;
                .carousel-3d-slide {
                    padding: 0px;
                    border-radius: 0px !important;
                    border-color: transparent !important;
                    border-style: hidden !important;
                    background-size: unset !important;
                    background-color: transparent !important;
                    height: 545px !important;
                    .licenses-panel {
                        margin: 0;
                }
            }
        }
    }

        .owl-stage {
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;

            -webkit-flex-wrap: wrap;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }

        .owl-item{
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            height: auto !important;
    }

    }

        @media screen and (max-width: 900px) {
        .licenses{
            margin-left: -14px ;
            margin-right: -14px;

            .widget-title{
                margin-left: 20px;
        }

            .licenses-panel{
                margin-left: 0px;
                margin-right: 6px;
                width: 100%;
        }
    }
    }

        @media screen and (max-width: 650px) {
        .licenses{
            margin-left: -14px ;
            margin-right: -14px;
            margin-bottom: 80px;

            .licenses-panel{
                margin-left: 0px;
                margin-right: 6px;
                width: 100%;
        }

            .licenses-wrapper{
                display: block !important;
        }

            .owl-carousel{
                display: none !important;
        }
    }
    }

        @media screen and (max-width: 500px) {
        .licenses{
            margin-left: -14px ;
            margin-right: -14px;

            .widget-title{
                margin-left: 20px;
        }

            .licenses-panel{
                margin-left: 0px;
                margin-right: 6px;
                width: 100%;
        }

            .licenses-wrapper{
                display: block !important;
        }

            .owl-carousel{
                display: none !important;
        }
    }
    }


</style>
<template>
    <div ref="licensesContainer" class="licenses">
        <h3 class="widget-title" :style="$highlightColor">Licenses</h3>

        <div class="licenses-wrapper" ref="div-licenses" id="div-licenses">
            <carousel-3d v-if="activeLicenses.length > 2 || (desktopViewport <= 650 && activeLicenses.length <= 2)" :controlsVisible="showNav" dir="ltr" @before-slide-change="onAfterSlideChange"
                         :startIndex="activeI" :perspective="0" :space="250" :display="activeLicenses.length" :width="320" :height="530" :border="0">
                <slide v-for="(license, i) in activeLicenses" :key="i" :index="i">
                    <license-row :current="i == lindex" :style="[i == lindex ? $gradientBackground : '']" :license="license" :showDiscounts="true" :user="user" :toggle-license-terms="false" :img="i"></license-row>
                </slide>
            </carousel-3d>

            <license-row v-else v-for="(license, i) in activeLicenses" :key="i" :current="i == lindex" :style="[i == lindex ? $gradientBackground : '']" :license="license"
                         :showDiscounts="true" :user="user" :toggle-license-terms="false" :img="i" :class="{'simple-block' : activeLicenses.length <= 2} "></license-row>

        </div>

    </div>
</template>

<script>
    import LicenseRow from './../licenserow.vue'
    import Carousel3d from './../carousel3d/Carousel3d.vue'
    import Slide from './../carousel3d/Slide.vue'
    import OwlCarousel from './../../../../marketplace/components/owlcarousel.vue'
    import Configure from './../../mixins/configure'

    export default {
        mounted() {
            if (this.desktopViewport <= 768 ) {
                this.showNav = true;
            }else{
                this.showNav = false;
            }
            this.lindex = this.activeI;
        },
        watch: {
            desktopViewport(val) {
                if (val <= 768 ) {
                    this.showNav = true;
                }else{
                    this.showNav = false;
                }
            },
        },
        components: { Carousel3d,Slide ,LicenseRow ,OwlCarousel},
        data(){
            return{
                owlCarousel: {
                    featured: {
                        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
                    }
                },
                startIndex : 2,
                lindex : this.activeI,
                showNav : false
            }
        },
        computed : {
            config() {
                return this.$store.state.currentConfig
            },
            user() {
                return this.$store.state.user
            },
            activeLicenses() {
                return _.filter(this.user.licenses, license => license.enabled);
            },

            activeI() {
                let vm = this;
                let i = Math.ceil(vm.activeLicenses.length / 2);
                _.filter(this.user.licenses, function(license , index){
                    if (vm.config.license == license.id){
                        i = index
                    }

                });
                return i;
            },

            desktopViewport() {
                return this.$store.state.viewPortWidth
            },
        },
        mixins: [Configure],
        methods: {
            onAfterSlideChange(index) {
                this.lindex = index;
            }
        }
    }
</script>